<template lang="pug">
  MainAsideRightHead(
      :title="idx !== '' ? 'Редактирование папку' : 'Создание папку'"
      storePath="coursesFolder"
      :canSave="canSave"
      :optionsVisible="false"
      :saveText="idx !== '' ? 'Сохранить' : 'Создать папку'"
      @save="save"
    )

</template>

<script>
import MainAsideRightHead from '@/components/MainAsideRight/MainAsideRightHead';
import { mapState } from 'vuex';

export default {
  components: { MainAsideRightHead },
  computed: {
    ...mapState('coursesFolder', {
      canSave: s => s.aside.meta.canSave,
      idx: s => s.aside.data.idx
    })
  },
  methods: {
    save() {
      if (!this.canSave) {
        return;
      }

      if (this.idx) {
        this.$store.dispatch('coursesFolder/editFolder');
      } else {
        this.$store.dispatch('coursesFolder/createFolder');
      }
      this.closeAside();
    },
    closeAside() {
      this.$store.dispatch('coursesFolder/setAsideMeta', {
        path: 'forceClose',
        value: true
      });
    }
  }
};
</script>
